import { Expose } from 'class-transformer';
import { SurveyElement } from './element';

export class SurveyImageElement extends SurveyElement {
  @Expose({ name: 'url' })
  src!: string | null;

  @Expose({ name: 'alter_text' })
  alt!: string | null;
}
